import React from 'react'
import { Plan } from '../types'
import { ALL_ACCOUNTS } from '../lib/accounts'
import { inputBase } from './Field'

const ADD = '__add'

interface Props {
  plan: Plan
  /** An account id, or ALL_ACCOUNTS. */
  value: string
  onChange: (value: string) => void
  onAddAccount: () => void
  className?: string
}

/**
 * Which account the app is showing, or all of them together. A native select
 * so that on a phone it opens the system picker rather than a cramped menu.
 */
export default function ScopeSelect({ plan, value, onChange, onAddAccount, className = '' }: Props) {
  return (
    <select
      aria-label="Account"
      className={`${inputBase} ${className}`}
      value={value}
      onChange={(e) => {
        if (e.target.value === ADD) onAddAccount()
        else onChange(e.target.value)
      }}
    >
      {/* With one account, "all of them" is the same thing twice. */}
      {plan.accounts.length > 1 && <option value={ALL_ACCOUNTS}>All accounts</option>}
      {plan.accounts.map((a) => (
        <option key={a.id} value={a.id}>
          {a.name}
        </option>
      ))}
      <option value={ADD}>+ Add account…</option>
    </select>
  )
}
